import angular from 'angular';
import booksMenu from '../../menu/Menu';
import './styles.css';

export default angular
  .module('checksReport', [booksMenu])
  .controller('checksController', Controller)
  .name;

/**
 * @ngdoc  controller
 * @module checksReport
 * @name   checksReport.checksReport.controller:controller
 * @description
 * This provides access to generate a report on checks utilizing
 * the available filters.
 */
/* @ngInject */ function Controller(
  $q,
  $scope,
  BusyScreen,
  Session,
  AccountType,
  BooksSvc
) {
  /** Report Request. */
  $scope.req = { reportFormat: 'PDF', status: 'A' };

  /** Get session path from root for report request. */
  $scope.actionPath = Session.getSessionURL('CheckReport.aspx');

  /*------------------------------------------------*/
  /* Static array for the status source dropdown. */
  /*------------------------------------------------*/
  $scope.statusSource = [
    { label: 'All', status: 'A' },
    { label: 'Handwritten', status: 'H' },
    { label: 'Printed', status: 'P' },
    { label: 'To Be Printed', status: 'TP' },
    { label: 'Void', status: 'V' },
    { label: 'Cleared', status: 'C' }
  ];

  /*------------------------------------------------*/
  /* Works with the CSMValidator to make sure the   */
  /* account fields and the paid to field, when the */
  /* individual options is selected, are populated. */
  /*------------------------------------------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*-------------------------*/
  /* Initialize data sources */
  /*-------------------------*/
  $q.all([
    BooksSvc.getOrganization().then(function (resp) {
      $scope.org = resp.data;
    }),
    BooksSvc.viewChartOfAccounts().then(function (resp) {
      $scope.accounts = resp.data.filter(function (acct) {
        return acct.type == AccountType.BANK;
      });
    })
  ]).then(function () {
    /*----------------------------------------------------*/
    /* Set default account after sources have been loaded */
    /*----------------------------------------------------*/
    $scope.req.bankID = $scope.org.defaultBankID;
    BusyScreen.setBusy(false);
  });
}
